import type { flightRequestItem, flightResponseItem } from '@/model/baseModel';

interface flightSearchItem {
  cid: string;
  adultNum: number;
  childNum: number;
  infantNum: number;
  studentNum: number;
  seamanNum: number;
  laborNum: number;
  fromCity: string;
  toCity: string;
  fromDate: string;
  retDate?: string;
  tripType: number;
  otaCarrier?: string;
  cabinGrades: string[];
  currency: string;
}
interface flightSearchResponse {
  msg: string;
  status: number;
  routings: flightSearchItem[];
}

interface checkPriceParams {
  cid: string;
  data: string;
}

interface priceCheckResult {
  diffAmt: string | number;
  maxSeats: string | number;
  msg: string;
  status: string | number;
  sessionId: string;
  rule?: any;
  routing?: any;
}

export const ApiSearchFlight = (params: flightRequestItem) => {
  return new Promise((resolve, reject) => {
    onRequest('post', '/search-url/PolarisQuery/query', params)
      .then((data: any) => {
        let res = data.data._value;
        resolve(res);
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};

export const ApiGetFareRule = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/order-url/PolarisOrder/fare/rule/text', params)
      .then((data: any) => {
        let res = data.data._value;
        res = JSON.parse(res);
        if (res.status == 0) {
          resolve(res);
        }
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
// 验价
export const ApiCheckPrice = (params: checkPriceParams) => {
  return new Promise((resolve, reject) => {
    onRequest('post', '/order-url/PolarisOrder/price/verify', params)
      .then((data: any) => {
        let res = data.data._value;
        resolve(res);
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};

export const createOrder = (params: any) => {
  return new Promise((resolve, reject) => {
    onRequest('post', '/order-url/PolarisOrder/create/order', params)
      .then((data: any) => {
        let res = data.data._value;
        resolve(res);
        // if (res.status == 0) {
        //   resolve(res)
        // }
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
export const getCo = (params: any) => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/order-url/PolarisOrder/co2/emission', params)
      .then((data: any) => {
        let res = data.data._value;
        resolve(res);
        // if (res.status == 0) {
        //   resolve(res)
        // }
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
export const getOrderPriceVerify = (params: any) => {
  return new Promise((resolve, reject) => {
    onRequest('post', '/order-url/PolarisOrder/price/verify', params)
      .then((data: any) => {
        let res = data.data._value;
        resolve(res);
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
export const payOrderPay = (params: any) => {
  return new Promise((resolve, reject) => {
    onRequest('post', '/order-system-url/PolarisOrderSystem/pay/orderPay', params)
      .then((data: any) => {
        let res = data.data._value;
        resolve(res);
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
// 支付接口
export const orderPayCheckStatusApi = (params: any) => {
  return new Promise((resolve, reject) => {
    onRequest('post', '/order-system-url/PolarisOrderSystem/pay/paymentCheck', params)
      .then((data: any) => {
        let res = data.data._value;
        resolve(res);
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
// 支付状态查询'/PolarisOrderSystem/pay/checkStatus'
export const getPayCheckStatus = (params: any) => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/order-system-url/PolarisOrderSystem/pay/checkStatus', params)
      .then((data: any) => {
        let res = data.data._value;
        resolve(res);
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
// 退票改签
export const orderChangeSystemStatus = (params: Object) => {
  return new Promise((resolve, reject) => {
    onRequest('post', '/order-system-url/PolarisOrderSystem/rest/order/changeReq', params)
      .then((data: any) => {
        let res = data.data._value;
        resolve(res);
      });
  });

};
// 解锁
export const ApiCorrentbackUnLocal = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/order-system-url/PolarisOrderSystem/pay/backUnLocal', params)
      .then((data: any) => {
        let res = data.data._value;
        if (res.status == 0) {
          resolve(res.data);
        }
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};